import { divide } from "lodash";
import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom'
import { useSelector, shallowEqual } from 'react-redux'
import { Grid, InputLabel, FormControl, Input, Snackbar } from "@material-ui/core";
import { UpdateInfo, GetCoach } from '../api/index'
import MuiAlert from '@material-ui/lab/Alert';


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const EmployInfo = () => {
  const history = useHistory();

  const [form, setForm] = useState({
    qualification: '',
    description: '',
    specialities: '',
    pending: false
  })

  const [snackbar, setSnackbar] = useState(()=>({
    isOpen: false,
    message: '',
    type: 'success'
  }))

  const [loading, setLoading] = useState(true);

  const { user } = useSelector(({ auth }) => auth, shallowEqual);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let userId = user.id;

    if(form.qualification == '' || form.description == '' || form.specialities == ''){
      setSnackbar({
        isOpen: true,
        message: 'Please fill all fields',
        type: 'error'
      })
      return;
    }

    console.log(form, userId);
    setForm((pre)=>({
      ...pre,
      pending: true
    }));
    const res = await UpdateInfo(form, userId);
    setSnackbar({
      isOpen: true,
      message: res.message,
      type: 'success'
    })
    setForm((pre)=>({
      ...pre,
      pending: false
    }))
  }

  const handleChange = (e) => {
    e.persist();
    // console.log(e);
    setForm((pre)=>({
        ...pre,
        [e.target.name]: e.target.value
    }))

  }
  useEffect(()=>{
    (async function(){
      setLoading(true);
      const res = await GetCoach(user.id);
      setForm({
        description: res.data.description,
        pending: false,
        qualification: res.data.qualification,
        specialities: res.data.specialities
      })
      setLoading(false);
      console.log(res);
    })();
  }, [])

  return (
    <>
      { loading ? <div style={{textAlign: 'center'}}><div style={{color: '#FF4242'}} class="spinner-border mx-auto" role="status"></div></div> :
      <div className="">
      <Snackbar open={snackbar.isOpen} autoHideDuration={6000} onClose={()=>{setSnackbar((pre)=>({...pre, isOpen: false}))}}>
            <Alert onClose={()=>{setSnackbar((pre)=>({...pre, isOpen: false}))}} severity={snackbar.type}>
                { snackbar.message }
            </Alert>
        </Snackbar>
      <div className="serviceTitle">
        <h1>Coach Information</h1>
      </div>
      <div className="container mt-5 ml-0 p-0" style={{ maxWidth: "750px" }}>
        <form onSubmit={handleSubmit} className="add-service-form mt-5">
          <div className="row">
            {/* <div className="col-md-6 mt-5">
              <input
                className="form-control"
                name="title"
                type="text"
                placeholder="Name"
              />
            </div>
            <div className="col-md-6 mt-5">
              <input
                className="form-control"
                name="title"
                type="text"
                placeholder="Qualification"
              />
            </div> */}

            <div className="col-md-6 mt-5">
              <h5>Qualification and Experience</h5>
              <textarea
                rows={5}
                placeholder="Qualification and Experience"
                className="form-control form-control-lg"
                onChange={handleChange}
                name="qualification"
                value={form.qualification}
              ></textarea>
            </div>
            <div className="col-md-6 mt-5">
              <h5>Specialities</h5>
              <textarea
                rows={5}
                placeholder="Specialities"
                className="form-control form-control-lg"
                onChange={handleChange}
                name="specialities"
                value={form.specialities}
              ></textarea>
            </div>

            <div className="col-md-12 mt-5">
              <h5>Description</h5>
              <textarea
                rows={5}
                placeholder="Description"
                className="form-control form-control-lg"
                onChange={handleChange}
                name="description"
                value={form.description}
              ></textarea>
            </div>
            <div className="row mt-5">
              <div className="col-md-12 mt-5">
                <button type="submit" className="submit-btn" disabled={form.pending}>
                  { form.pending ? <div class="spinner-border text-white mx-auto" role="status"></div> : 'Submit' }
                </button>
                {/* <button className="cancel-btn ml-5" onClick={()=>{history.push('/dashboard')}}>Cancel</button> */}
                <button className='form_btn form_btn1 ml-5' style={{borderColor: '#ff4242', color: '#ff4242'}} onClick={()=>{history.push('/dashboard')}}>Cancel</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    }
    </>
  );
};

export default EmployInfo;
